// extracted by mini-css-extract-plugin
export default {"container":"Eot9rtem9EWc4VzI9DCe","logo":"o5ZjeYXytKtm_6pWjY1J","privacyLinks":"ubLJVaw3RRubOTSUT3PB","link":"ELHuL2ldS7BR1UNDBDuC"};